import { useTranslation } from 'react-i18next';

// "DTD" (day to day), "OUT" or "IR" next to a player's name; nothing for a healthy one.
export function InjuryBadge({ level }: { level: number }) {
    const { t } = useTranslation();
    if (!(level > 0)) {
        return null;
    }
    if (level === 1) {
        return <span className="badge" title={t('injury_dtd')}>DTD</span>;
    }
    if (level === 2) {
        return <span className="badge out" title={t('injury_out')}>OUT</span>;
    }
    return <span className="badge ir" title={t('injury_ir')}>IR</span>;
}
